<template>
  <el-form
    ref="formRef"
    :model="form"
    :rules="rules"
    label-width="100px"
    style="max-width: 620px; padding: 34px 16px 12px 0; box-sizing: border-box"
    @submit.prevent=""
  >
    <el-form-item label="账号" prop="userId">
      <div>{{ form.userid }}</div>
    </el-form-item>
    <el-form-item label="姓名" prop="userName">
      <div>{{ form.username }}</div>
    </el-form-item>
    <el-form-item label="性别" prop="sex">
      <el-select
        clearable
        v-model="form.sex"
        placeholder="请选择性别"
        class="ele-fluid"
      >
        <el-option :value="1" label="男" />
        <el-option :value="0" label="女" />
        <el-option :value="2" label="密" />
      </el-select>
    </el-form-item>
    <el-form-item label="手机号" prop="phone">
      <!-- data.phone?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') -->
      {{ data.phone || '未设置' }}
    </el-form-item>
    <el-form-item label="邮箱" prop="email">
      <!-- data.email?.replace(/(.+?)(.{4})(.{4})@/, '$1****$2@') -->
      {{ data.email || '未设置' }}
    </el-form-item>
    <el-form-item label="学历" prop="education">
      <el-input
        clearable
        :maxlength="100"
        v-model="form.education"
        placeholder="请输入学历"
      />
    </el-form-item>
    <el-form-item label="学位" prop="degree">
      <el-input
        clearable
        :maxlength="100"
        v-model="form.degree"
        placeholder="请输入学位"
      />
    </el-form-item>
    <el-form-item label="职称" prop="job">
      <el-input
        clearable
        :maxlength="100"
        v-model="form.job"
        placeholder="请输入职称"
      />
    </el-form-item>
    <el-form-item label="个人简介">
      <div style="text-align: right; width: 100%"
        ><el-button
          type="primary"
          plain
          @click="handleAiAssistance"
          size="small"
          :loading="aiLoadingSmartProfile"
          ><el-icon><MagicStick /></el-icon>AI自动构建</el-button
        ></div
      >
      <el-input
        type="textarea"
        :rows="4"
        :maxlength="200"
        v-model="form.profile"
        placeholder="请输入个人简介"
      />
    </el-form-item>
    <el-form-item label="签名图片" prop="sign">
      <div>
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 15px;
          "
        >
          <div class="user-sign-image-box el-textarea" @click="openCropper">
            <el-image
              class="user-sign-image"
              v-if="signImageUrl"
              :src="signImageUrl"
            />
            <div class="signature-card" v-else>
              <div class="signature-placeholder text-sm"> 点击编辑签名 </div>
            </div>
            <el-icon class="user-sign-image-icon">
              <CloudUploadOutlined style="stroke-width: 3" />
            </el-icon>
          </div>
          <!-- url 参数 ?lzd-dev=true 可显示 -->
          <el-button v-show="isDev" @click="autoSignImage">自动构建</el-button>
          <el-button @click="openCropperAndUpload" style="margin-left: 0px">
            上传签名
          </el-button>
          <el-button v-if="false" @click="openSign" style="margin-left: 0px">
            手写签名
          </el-button>
        </div>

        <ele-text type="placeholder" style="line-height: 1.5em"
          >请提供一张仅用于自动嵌入毕业设计文档中签名位置的图片，要求图片背景为白色，签名文字为黑色，并确保图片清晰、专业，以便在文档中进行无缝插入。</ele-text
        >
      </div>
    </el-form-item>
    <el-form-item v-if="!hidenSaveBtn">
      <el-button type="primary" :loading="loading" @click="save">
        {{ loading ? '保存中..' : '保存更改' }}
      </el-button>
    </el-form-item>
    <!-- 头像裁剪弹窗 -->
    <ele-cropper-modal
      v-model="visible"
      :src="signImageUrl"
      :options="{
        aspectRatio: 3,
        autoCropArea: 1,
        viewMode: 0,
        dragMode: 'move'
      }"
      :to-blob="true"
      :modal-props="{ destroyOnClose: true }"
      @done="onCrop"
      :beforeUploadClick="handleBeforeUploadClick"
      tools="zoomIn,zoomOut | moveLeft,moveRight,moveUp,moveDown | rotateLeft,rotateRight | flipX,flipY | upload | ok"
      @open="onOpen"
    />
  </el-form>
  <handwrittenSign v-model="showSign" @done="replace" />
</template>

<script lang="ts" setup>
  import { ref, reactive, computed, unref } from 'vue';
  import {
    ElMessageBox,
    type FormInstance,
    type FormRules
  } from 'element-plus';
  import { EleMessage } from 'ele-admin-plus/es';
  import { useFormData } from '@/utils/use-form-data';
  import { updateUserInfo } from '@/api/bsl/tenant/user';
  import { CloudUploadOutlined } from '@/components/icons';
  import fileUtil, { FileUploadPkConfig } from '@/utils/file-util';
  import type { TenantUser } from '@/api/bsl/tenant/user/model';
  import tenantStudentApi from '@/api/bsl/tenant/user/student';
  import tenantTeacherApi from '@/api/bsl/tenant/user/teacher';
  import LzdAjax from '@/utils/lzd-ajax';
  import { usePermission } from '@/utils/use-permission';
  import { MagicStick } from '@element-plus/icons-vue';
  import handwrittenSign from './handwritten-sign.vue';
  import type { TenantStudent, TenantTeacher } from '@/api';
  import { IS_DEV } from '@/config/setting';
  import { useRouter } from 'vue-router';

  const isLoacl =
    location.hostname.includes('localhost') ||
    location.hostname.startsWith('127.0.0.') ||
    location.hostname.startsWith('192.168.4.');

  const props = withDefaults(
    defineProps<{
      data: TenantUser;
      hidenSaveBtn?: boolean;
    }>(),
    {
      hidenSaveBtn: false
    }
  );
  const { hasRole } = usePermission();

  const router = useRouter();
  const { currentRoute } = router;
  const { query } = unref(currentRoute);
  const isDev = computed(
    () => isLoacl || IS_DEV || query['lzd-dev'] === 'true'
  );

  const emit = defineEmits<{
    (e: 'done', value: TenantUser): void;
  }>();

  // 签名剪裁后的文件
  let signImageFile: File | null = null;
  const signImageUrl = ref('');
  /** 是否显示裁剪弹窗 */
  const visible = ref(false);
  /** 打开图片裁剪 */
  const openCropper = () => {
    visible.value = true;
  };
  /** 打开图片裁剪并打开上传图片 */
  const isUploadClick = ref(false);
  const openCropperAndUpload = () => {
    visible.value = true;
    isUploadClick.value = true;
  };

  /** 裁剪弹窗上传按钮回调 */
  let currentCropperCallback: any = null;

  let revokeObjectURLStr: string | null = null;
  /** 裁剪弹窗上传按钮点击打开文件选择弹窗 */
  const handleBeforeUploadClick = (_e, onResult) => {
    // onResult 用于回调选择的图片, 要在 FilePicker 选择后调用并传递选择的图片
    currentCropperCallback = onResult;
    // currentCropperCallback(files[0].url, files[0].contentType);
    const inputEl = document.createElement('input');
    inputEl.style.display = 'none';
    inputEl.type = 'file';
    inputEl.accept = '.png, .jpg, .jpeg';
    document.body.appendChild(inputEl);

    revokeObjectURLStr && URL.revokeObjectURL(revokeObjectURLStr);
    revokeObjectURLStr = null;
    inputEl.addEventListener('change', () => {
      const file = inputEl.files![0];
      if (file.size < 2048) {
        EleMessage.error('上传失败，请重新处理');
        return false;
      }
      if (!/\.(png)|(jpe?g)/i.test(file.name.toLowerCase())) {
        EleMessage.warning('仅支持 .png, .jpg, .jpeg 格式');
        return false;
      }
      revokeObjectURLStr = URL.createObjectURL(file);
      checkImageTransparencyRatio(
        revokeObjectURLStr,
        (err, isTwoThirdsTransparent, transparencyRatio) => {
          if (err || !isTwoThirdsTransparent) {
            const loading = EleMessage.loading({
              message: '背景切割中...',
              mask: false,
              centered: true
            });
            fileUtil
              .imageSegmentation(file)
              .then((base64Str: string) => {
                currentCropperCallback(
                  `data:image/png;base64,${base64Str}`,
                  'image/png'
                );
              })
              .catch((_) => {
                currentCropperCallback(
                  (revokeObjectURLStr = URL.createObjectURL(file)),
                  file.type
                );
              })
              .finally(() => {
                loading.close();
              });
          } else {
            currentCropperCallback(URL.createObjectURL(file), file.type);
          }
        }
      );
      // currentCropperCallback(URL.createObjectURL(file), file.type);
    });
    inputEl.click();
    return false;
  };

  /** 检测透明区域占 2/3 */
  function checkImageTransparencyRatio(
    imageSrc: string,
    callback: (err: Error | null, a?: boolean, b?: number) => void
  ) {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // 如果图片跨域，需要服务器支持 CORS

    img.onload = function () {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d')!;

      canvas.width = img.width;
      canvas.height = img.height;

      // 将图片绘制到 canvas
      ctx.drawImage(img, 0, 0);

      // 获取像素数据
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      const totalPixels = canvas.width * canvas.height;
      let transparentPixels = 0;

      // 遍历每个像素
      for (let i = 0; i < data.length; i += 4) {
        const alpha = data[i + 3]; // Alpha 通道 (0-255)

        if (alpha < 255) {
          // 若Alpha值小于255，则认为该像素是透明或半透明
          transparentPixels++;
        }
      }

      // 计算透明像素比例
      const transparencyRatio = transparentPixels / totalPixels;

      // 判断透明像素是否超过总面积的三分之二
      const isTwoThirdsTransparent = transparencyRatio >= 2 / 3;

      callback(null, isTwoThirdsTransparent, transparencyRatio);
    };

    img.onerror = function () {
      callback(new Error('Failed to load image.'));
    };

    img.src = imageSrc;
  }

  /** 提交状态 */
  const loading = ref(false);

  /** 表单实例 */
  const formRef = ref<FormInstance | null>(null);

  /** 表单数据 */
  const [form, _resetFields, assignFields] = useFormData<Partial<TenantUser>>({
    userid: '',
    username: '',
    sign: '',
    sex: void 0,
    // phone: '',
    // email: '',
    degree: '',
    education: '',
    job: '',
    profile: ''
  });

  /** 表单验证规则 */
  const rules = reactive<FormRules>({});

  /** 保存更改 */
  const save = () => {
    formRef.value?.validate?.((valid) => {
      if (!valid) {
        return;
      }
      loading.value = true;

      const _func = async () => {
        signImageFile = null;
        const user = { ...form };
        delete user.userid;
        delete user.username;
        const res = await updateUserInfo(user as TenantUser);
        if (form.degree || form.education) {
          const update = hasRole('student')
            ? tenantStudentApi.studentUpdateByUserid
            : tenantTeacherApi.teacherUpdateByUserid;
          const updateData = {
            userid: props.data.userid!
          } as TenantTeacher | TenantStudent;

          if (form.degree) {
            updateData.degree = form.degree;
          }

          if (form.education) {
            updateData.education = form.education;
          }
          await update({
            userid: form.userid,
            degree: form.degree,
            education: form.education
          });
        }
        emit('done', res);
        loading.value = false;
        EleMessage.success('保存成功');
      };

      if (signImageFile) {
        fileUtil
          .uploadFile(FileUploadPkConfig.signatureImage, signImageFile)
          .then((data: any) => {
            form.sign = data.fileUrl;
            _func();
          })
          .catch((e) => {
            EleMessage.error(e.message);
          });
      } else {
        _func();
      }
    });
  };

  // 回显当前登录用户信息
  assignFields({
    ...props.data,
    email: props.data.email || '',
    tellPre: props.data.phone || ''
  });
  console.log(props.data);

  signImageUrl.value = props.data.sign || '';

  /** 打开签名剪裁后修改页面 */
  const onOpen = () => {
    let tools = document.getElementsByClassName('ele-cropper-tools')[0];
    let button = tools.getElementsByTagName('button');
    for (let i = 0; i < 10; i++) {
      // 向每个元素添加HTML内容
      button[i].style.color = 'black';
      button[i].style.backgroundColor = 'white';
    }
    button[10].style.borderRadius = '5px 5px 5px 5px';

    let upload = document.getElementsByClassName('ele-cropper-upload')[0];
    upload.insertAdjacentHTML(
      'beforeend',
      '<p style="padding-left: 4px">上传</p>'
    );
    if (isUploadClick.value) {
      upload.click();
      isUploadClick.value = false;
    }
  };

  /** 头像裁剪完成回调 */
  const onCrop = async (cropResult: Blob) => {
    visible.value = false;
    signImageFile = new File([cropResult], 'sign-image.png');
    revokeObjectURLStr && URL.revokeObjectURL(revokeObjectURLStr);
    revokeObjectURLStr == null;
    signImageUrl.value = revokeObjectURLStr =
      URL.createObjectURL(signImageFile);
  };

  // --- AI 辅助功能实现 ---
  const aiLoadingSmartProfile = ref(false);
  const aiError = ref(''); // AI 错误信息
  const API_KEY = 'sk-6LTu1GkJ9byjldZJF9D487C8A3D640F990FfEbE0BeB2B18f';
  const API_URL = 'https://api.vansai.cn/v1/chat/completions';

  /**
   * 处理 AI 辅助功能请求
   */
  async function handleAiAssistance() {
    aiError.value = ''; // 清空之前的错误信息
    form.profile = ''; // 在开始流式输出新意见前，清空之前的意见

    // 准备发送给 AI 的信息
    // 在实际应用中，您可能需要发送更多上下文信息，
    // 甚至在可行和允许的情况下发送文档内容。
    const studentName = form.username || '该生';
    const studentId = form.userid || '未知学号';

    let systemContent = '你是一个乐于助人的助手。'; // 系统角色指令
    let userContent = ''; // 用户输入内容

    systemContent = `你是一个文案生成专家，你需要完成以下内容：`;
    userContent = `【学生信息】
        姓名：${studentName}
        学号：${studentId}
        性别：${form.sex == 0 ? '女' : form.sex == 1 ? '男' : '密'}
        身份：在校大学生
        专业：

    【核心信息】`;
    ElMessageBox.prompt('', '提示词调整', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputType: 'textarea',
      inputValue: userContent,
      inputValidator: (value) => {
        if (!value.trim()) {
          return '不能为空';
        }
        return true;
      }
    })
      .then(async ({ value }) => {
        aiLoadingSmartProfile.value = true;

        try {
          const tip =
            value +
            `【格式与语气】
        - 字数控制：200字左右
        - 语气要求：客观中立，用具体行为描述替代抽象评价（如“能主动组织小组讨论”而非“团队协作能力强”）
        - 结构建议：分“优点+待提升+总体评价”三段式

        【禁忌提示】
        - 避免使用“潜力较大”“必将取得进步”等推测性表述（若需保留，可改为“在持续努力下有望进一步突破”） `;
          const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${API_KEY}`
            },
            body: JSON.stringify({
              model: 'qwen-max-latest',
              stream: true,
              messages: [
                { role: 'system', content: systemContent },
                { role: 'user', content: tip }
              ]
            })
          });

          if (!response.ok) {
            const errorData = await response
              .json()
              .catch(() => ({ message: response.statusText })); // 尝试解析错误体，失败则用状态文本
            throw new Error(
              `AI服务请求失败: ${response.status} ${errorData.message || ''}`
            );
          }

          if (!response.body) {
            throw new Error('AI响应体为空');
          }

          // 处理流式响应
          const reader = response.body.getReader();
          const decoder = new TextDecoder('utf-8');
          let buffer = ''; // 用于存储未完整处理的文本块

          while (true) {
            const { done, value } = await reader.read();
            if (done) {
              break; // 读取完毕
            }
            buffer += decoder.decode(value, { stream: true }); // 解码并追加到缓冲区

            // 按行处理SSE消息
            // 假设API以SSE格式流式传输数据，例如:
            // data: {"id":"...","object":"chat.completion.chunk","created":...,"model":"...","choices":[{"index":0,"delta":{"content":"some text"},"finish_reason":null}]}
            // vansai API示例（非流式）暗示它是直接JSON。对于流式，通常是delta内容。
            let boundary = buffer.lastIndexOf('\n'); // 查找最后一个换行符作为消息边界
            if (boundary === -1 && !done) continue; // 如果没有换行符且未结束，则等待更多数据

            let linesToProcess = buffer.substring(0, boundary); // 获取待处理的完整行
            buffer = buffer.substring(boundary + 1); // 保留不完整的部分到下一次处理

            const lines = linesToProcess
              .split('\n')
              .filter((line) => line.startsWith('data: ')); // 分割并过滤出数据行

            for (const line of lines) {
              const jsonString = line.substring(5).trim(); // 移除 "data: " 前缀
              if (jsonString === '[DONE]') {
                // OpenAI 特定流结束信号
                break;
              }
              try {
                const parsed = JSON.parse(jsonString); // 解析JSON块
                if (
                  parsed.choices &&
                  parsed.choices[0] &&
                  parsed.choices[0].delta &&
                  parsed.choices[0].delta.content
                ) {
                  form.profile += parsed.choices[0].delta.content; // 追加内容到审核意见
                }
              } catch (e) {
                console.warn('AI Stream: 解析JSON块失败:', jsonString, e);
              }
            }
            if (lines.some((line) => line.substring(5).trim() === '[DONE]'))
              break; // 如果收到[DONE]信号，则跳出外层循环
          }
          // 处理缓冲区中可能剩余的最后一部分数据
          if (buffer.startsWith('data: ')) {
            const jsonString = buffer.substring(5).trim();
            if (jsonString !== '[DONE]') {
              try {
                const parsed = JSON.parse(jsonString);
                if (
                  parsed.choices &&
                  parsed.choices[0] &&
                  parsed.choices[0].delta &&
                  parsed.choices[0].delta.content
                ) {
                  form.profile += parsed.choices[0].delta.content;
                }
              } catch (e) {
                console.warn('AI Stream: 解析最后JSON块失败:', jsonString, e);
              }
            }
          }
        } catch (error: any) {
          console.error('AI 辅助功能错误:', error);
          aiError.value =
            error.message || 'AI 辅助功能出错，请稍后重试或手动填写。';
          form.profile += `\n[AI 助手提示：内容生成可能未完成，遇到错误: ${aiError.value}]`;
        } finally {
          // 重置加载状态

          aiLoadingSmartProfile.value = false;
        }
      })
      .catch(() => {});
  }

  // 自动构建
  const autoSignImage = () => {
    if (!form.username) {
      EleMessage.warning('姓名不能为空');
      return;
    }
    const loading = EleMessage.loading('构建中...');
    const formData = new FormData();
    formData.append('username', form.username);
    LzdAjax.post(
      'https://www.lun51.com/apis/pdf/util/generate-sign-image',
      formData,
      true,
      true
    )
      .then((v) => {
        if (typeof v.data !== 'string') {
          return;
        }
        signImageFile = fileUtil.base64ToFile(v.data);
        revokeObjectURLStr && URL.revokeObjectURL(revokeObjectURLStr);
        revokeObjectURLStr == null;
        signImageUrl.value = revokeObjectURLStr =
          URL.createObjectURL(signImageFile);
      })
      .finally(() => loading.close());
  };

  const showSign = ref(false);
  const openSign = () => {
    showSign.value = true;
  };

  const replace = (file: File) => {
    signImageFile = file;
    revokeObjectURLStr && URL.revokeObjectURL(revokeObjectURLStr);
    revokeObjectURLStr == null;
    signImageUrl.value = revokeObjectURLStr =
      URL.createObjectURL(signImageFile);
  };

  defineExpose({ save });
</script>

<style lang="scss" scoped>
  .form-tell {
    display: flex;
    align-items: center;
    width: 100%;

    .form-tell-prefix {
      width: 65px;
    }

    .form-tell-body {
      flex: 1;
      padding-left: 12px;
      box-sizing: border-box;
    }
  }

  .user-sign-image-box {
    width: 150px;
    height: 50px;
    position: relative;
    background: var(--el-text-color-disabled);
    border-radius: var(--ele-input-radius);

    .user-sign-image {
      width: 100%;
      height: 100%;
      border-radius: var(--ele-input-radius);
      box-sizing: border-box;
      object-fit: contain;
      padding: 0;
      margin: 0;
      display: block;
      border: 0;
      outline: 0;
    }

    .user-sign-image-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 30px;
      display: none;
      z-index: 2;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border-radius: var(--ele-input-radius);
      background-color: transparent;
      transition: background-color 0.3s;
      z-index: 1;
    }
    &:hover {
      cursor: pointer;
      .user-sign-image-icon {
        display: block;
      }
      &::after {
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
  }

  /* 签名卡片样式 */
  .signature-card {
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    padding: 4px;
    margin-right: 4px;
    background-color: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    width: 95%;
    height: 80%;
  }
  .signature-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed #9ca3af;
    border-radius: 4px;
    background-color: #f3f4f6;
    color: #6b7280;
    transition: all 0.3s ease;
    width: 100%;
    height: 100%;
  }
</style>
